import { useLoginMutation, useGetOrganizationQuery } from "@/redux/Login/Login";
import { useForgotPasswordMutation } from "@/redux/ForgotPassword/ForgotPasseord";
import { useEmailOtpMutation } from "@/redux/ForgotPassword/EmailOtp";
import { useResendOtpMutation } from "@/redux/ForgotPassword/ResendOtp";
import { useResetPasswordMutation } from "@/redux/ForgotPassword/SetNewPassword";
import {
  useGetDashboardQuery,
  useToggleLockMutation,
  useDeleteJobMutation,
} from "./ExportPage/Dashboard/DashboardSlice.js";
import {
  useLazyGetSezInfoByIdQuery,
  useUpdateSezInfoMutation,
} from "@/redux/ExportPage/CreateNewJob/Sez/SezInfoSlice.js";
import { useGetExportIdQuery } from "./ExportPage/Dashboard/ExportIdSlice.js";
import { useGetExportersQuery } from "@/redux/ExportPage/CreateNewJob/General/GeneralPageapiSlice";

import {
  useUpdateContainerMutation,
  useDeleteContainerMutation,
  useCreateContainerMutation,
  useLazyGetContainerByMasterIdQuery,
} from "@/redux/ExportPage/CreateNewJob/Container/ContainerSlice";

import {
  useLazyGetRequirementByMasterIdQuery,
  useCreateRequirementMutation,
  useUpdateRequirementMutation,
  useDeleteRequirementMutation,
} from "@/redux/ExportPage/CreateNewJob/Requirement/RequirementSlice.js"; //N
import {
  useLazyGetAdditionalInfoByIdQuery,
  useCreateAdditionalInfoMutation,
  useUpdateAdditionalInfoMutation,
  useDeleteAdditionalInfoMutation,
} from "@/redux/ExportPage/CreateNewJob/Product/SingleWindow/AdditonalInfoSlice.js";

import {
  useLazyGetControlDetailsByIdQuery,
  useCreateControlDetailMutation,
  useUpdateControlDetailMutation,
  useDeleteControlDetailMutation,
} from "@/redux/ExportPage/CreateNewJob/Product/SingleWindow/ControlSlice.js";

import {
  useLazyGetUdfByMasterIdQuery,
  useCreateUdfMutation,
} from "@/redux/ExportPage/CreateNewJob/UDF/UDFSlice.js";
import {
  useGetPackageDetailsByMasterIdQuery,
  useyGetPackageDetailsByIdQuery,
} from "@/redux/ExportPage/CreateNewJob/Container/ContainerPackageSlice";

import {
  useLazyGetInvoiceByMasterIdQuery,
  useCreateInvoiceMutation,
  useUpdateInvoiceMutation,
  useDeleteInvoiceMutation,
} from "@/redux/ExportPage/CreateNewJob/Invoice/InvoiceMainSlice";
import {
  useLazyGetInvoiceByIdQuery,
  useUpdateInvoiceFreightMutation,
} from "@/redux/ExportPage/CreateNewJob/Invoice/InvoicefreightSlice.js";
import {
  useGetInvoiceBuyerByMasterIdQuery,
  useLazyGetInvoiceBuyerByIdQuery,
  useUpdateInvoiceBuyerMutation,
} from "@/redux/ExportPage/CreateNewJob/Invoice/InvoiceBuyerSlice.js";
import {
  useGetInvoiceOtherinfoByMasterIdQuery,
  useLazyGetInvoiceOtherinfoByIdQuery,
  useCreateInvoiceOtherinfoMutation,
  useUpdateInvoiceOtherinfoMutation,
} from "@/redux/ExportPage/CreateNewJob/Invoice/InvoiceOtherInfoSlice.js";

import {
  useLazyGetConstituentsByIdQuery,
  useCreateConstituentMutation,
  useUpdateConstituentMutation,
  useDeleteConstituentMutation,
} from "@/redux/ExportPage/CreateNewJob/Product/SingleWindow/ConstituentSlice.js";

import {
  useLazyGetProductionDetailsByIdQuery,
  useCreateProductionDetailMutation,
  useUpdateProductionDetailMutation,
  useDeleteProductionDetailMutation,
} from "@/redux/ExportPage/CreateNewJob/Product/SingleWindow/ProductionSlice.js";
import {
  useLazyGetESanchitByMasterIdQuery,
  useGetExportInvoiceQuery,
  useUpdateESanchitMutation,
  useDeleteESanchitMutation,
  useCreateESanchitMutation,
  useLazyGetFilterESanchitQuery,
} from "@/redux/ExportPage/CreateNewJob/eSanchit/eSanchitSlice.js";
import {
  useCreateShipmentInvoiceMutation,
  useLazyGetShipmentInvoiceByIdQuery,
} from "@/redux/ExportPage/CreateNewJob/Shipment/ShipmentInvoicePrintSlice.js";
import {
  useUpdateShipmentStuffingMutation,
  useLazyGetShipmentStuffingByIdQuery,
} from "@/redux/ExportPage/CreateNewJob/Shipment/ShipmentStuffinglSlice.js";
import {
  useCreateProductGeneralMutation,
  useLazyGetAllGeneralQuery,
} from "./ExportPage/CreateNewJob/Product/General/ProductGeneralSlice.js";
import {
  useCreateExporterMutation,
  useUpdateExporterMutation,
} from "@/redux/ExportPage/CreateNewJob/General/GeneralPageapiSlice.js";
import { useLazyGetExportGeneralByIdQuery } from "@/redux/ExportPage/Dashboard/ExportIdSlice";
import {
  useCreateProductMainMutation,
  useUpdateProductMainMutation,
  useLazyGetProductInvoiceMainIdQuery,
  useDeleteProductMainMutation,
} from "./ExportPage/CreateNewJob/Product/Main/ProductMainSlice.js";
import {
  useCreateAnnexMutation,
  useLazyGetShipmentAnnexByIdQuery,
  useCreateDocumentMutation,
  useLazyGetShipmentDocumentByIdQuery,
  useUpdateDocumentMutation,
  useDeleteDocumentMutation,
} from "@/redux/ExportPage/CreateNewJob/Shipment/ShipmentAnnuexSlice.js";

import {
  useUpdateCessMutation,
  useLazyGetProductCessByIdQuery,
} from "@/redux/ExportPage/CreateNewJob/Product/ProductCess/CessSlice.js";

import {
  useCreateQuotaMutation,
  useUpdateQuotaMutation,
  useLazyGetProductQuotaByIdQuery,
  useDeleteQuotaMutation,
} from "@/redux/ExportPage/CreateNewJob/Product/QuotaSlice.js";

import {
  useLazyGetDrawBackByMasterIdQuery,
  useCreateDrawBackMutation,
} from "@/redux/ExportPage/CreateNewJob/Product/ProductDrawback/ProductDrawbackSlice.js";

import {
  useCreateShipmentBillMutation,
  useLazyGetShipmentBillByIdQuery,
} from "@/redux/ExportPage/CreateNewJob/Shipment/ShipmentbillprintSlice.js";

import {
  useLazyGetJobworkByMasterIdQuery,
  useUpdateJobworkMutation,
  useDeleteJobworkMutation,
  useCreateJobworkMutation,
} from "@/redux/ExportPage/CreateNewJob/Product/Jobwork/JobworkSlice.js";

import { useGetProductAREByIdQuery } from "@/redux/ExportPage/CreateNewJob/Product/ARESlice.js";
import {
  useCreateEntityMutation,
  useDeleteEntityMutation,
  useLazyGetEntityByMasterIdQuery,
  useUpdateEntityMutation,
} from "@/redux/ExportPage/CreateNewJob/Entity/EntitySlice.js";
import {
  useCreateExbondMutation,
  useUpdateExbondMutation,
  useDeleteExbondMutation,
  useLazyGetShipmentExbondByIdQuery,
} from "./ExportPage/CreateNewJob/Shipment/ShipmentEXbondSlice.js";
import {
  useLazyGetExchangeRateByIdQuery,
  useUpdateExchangeRateMutation,
} from "./ExportPage/CreateNewJob/ExchangeRate/ExchangeRate.js";
import {
  useCreateReExportMutation,
  useLazyGetProductReExportByIdQuery,
} from "@/redux/ExportPage/CreateNewJob/Product/ReExport/ReExportSlice.js";
import {
  useLazyGetOtherDetailsByIdQuery,
  useCreateOtherDetailMutation,
} from "@/redux/ExportPage/CreateNewJob/Product/Otherdetails/OtherdetailSlice.js";

import { useUpdateProductGeneralMutation } from "./ExportPage/CreateNewJob/Product/General/ProductGeneralSlice.js";
import {
  useCreateProductAreDetailsMutation,
  useLazyGetAreDetailsByIdQuery,
  useUpdateProductAreDetailsMutation,
  useDeleteProductAreDetailsMutation,
  useLazyGetAreDetailsQuery,
} from "./ExportPage/CreateNewJob/Product/Are Details/ProductAreDetails.js";
import {
  useCreateProductDEPBMutation,
  useLazyGetProductDEPBQuery,
  useCreateProductDEPBTableMutation,
  useLazyGetProductDEPBTableQuery,
  useUpdateProductDEPBTableMutation,
  useDeleteProductDEPBTableMutation,
} from "./ExportPage/CreateNewJob/Product/DEPB/DEPBSlice.js";

import {
  useLazyGetProductDFRCQuery,
  useCreateProductDFRCMutation,
  useUpdateProductDFRCMutation,
  useCreateProductDFRCTableMutation,
  useLazyGetProductDFRCTableQuery,
  useUpdateProductDFRCTableMutation,
  useDeleteProductDFRCTableMutation,
} from "./ExportPage/CreateNewJob/Product/DFRC/DFRCSlice.js";

import {
  useCreateProductDucInfoMutation,
  useLazyGetDucInfoDetailsByIdQuery,
  useUpdateProductDucInfoMutation,
  useDeleteProductDucInfoMutation,
} from "@/redux/ExportPage/CreateNewJob/Product/ProductDUC/ProductDucSlice.js";
import {
  useCreateProductDocInfoMutation,
  useLazyGetDocInfoDetailsByIdQuery,
  useUpdateProductDocInfoMutation,
  useDeleteProductDocInfoMutation,
} from "./ExportPage/CreateNewJob/Product/ProductDocInfo/ProductDocInfoSlice.js";
import {
  useCreateExportNotesMutation,
  useUpdateExportNotesMutation,
  useLazyGetNotesByExporterIdQuery,
  useDeleteExportNoteMutation,
  useFileUploadMutation,
} from "./ExportPage/CreateNewJob/Notes/NoteSlice.js";
import { useLazyGetHistoryQuery } from "@/redux/ExportPage/CreateNewJob/History/HistorySlice.js";
import { useGetExchangeMasterIdQuery } from "./ExportPage/CreateNewJob/Product/General/ProductGeneralSlice.js";
import { skipToken } from "@reduxjs/toolkit/query";
import { useUser } from "@/Context/UserContext.jsx";
import { useParams } from "react-router";
import { useGetAdCodeMasterQuery, useGetAirlineQuery, useGetFilterHsnCodeQuery, useLazyGetQualifierCodeQuery,useGetQualifierCodeQuery, useGetShiplineMasterQuery, useGetESanchitDocumentQuery } from "./Masters/Masters.js";
import {
  useCreateExportTrackingMutation,
  useUpdateExportTrackingMutation,
  useLazyGetTrackingByExportMasterIdQuery,
} from "../redux/ExportPage/CreateNewJob/Tracking/TrackingApi.jsx";

import {
  useGetPortsQuery,
  useGetCountryQuery,
  useGetQuantityQuery,
  useGetGatewayQuery,
  useGetInvoiceMasterQuery,
  useGetStateQuery,
  useGetCityQuery,
  useGetVolumeQuery,
  useGetExchangeQuery,
  useGetRateListMasterQuery,
  useGetDescriptionQuery,
  useGetHsnCodeMasterQuery,
  useGetEndUseCodeMasterQuery,
  useGetFTAMasterQuery,
  useGetDistrictMasterQuery,
  useGetIECodeQuery,
  useGetDrawerQuery,
  useGetCurrenciesQuery,
  useGetStateMasterQuery,
  useGetCFSQuery,
  useGetCustomeHouseQuery,
  useGetCityMasterQuery,
  useGetCustomertypeMasterQuery,
  useGetCustomerQuery,
  useGetEximCodeQuery,
  useGetShipingLineQuery,
  useLazyGetEximCodeQuery,
  useGetNotationQuery
} from "@/redux/Masters/Masters.js";
import { useGetLicQuery, useCreateMainShipmentMutation, useLazyGetMainShipmentByIdQuery } from "./ExportPage/CreateNewJob/Shipment/ShipmentMainSlice.js";
import {  useLazyGetCustomersAddressQuery, useGetCustomersQuery } from "./ExportPage/CreateNewJob/General/GeneralPageapiSlice.js";
import { useGetContactListQuery } from "./Masters/Masters.js";
import { useLazyGetDrawBackByCustomHouseIdQuery } from "./Organization/CreateNewCustomer/CustomeDetails/DrawBackDetails/Drawbackdetails.js";
import { useCreateProductDEECTableOneMutation, useCreateProductDEECTableTwoMutation, useDeleteProductDEECTableOneMutation, useDeleteProductDEECTableTwoMutation, useLazyGetProductDEECTableOneQuery, useLazyGetProductDEECTableTwoQuery, useUpdateProductDEECTableOneMutation, useUpdateProductDEECTableTwoMutation } from "./ExportPage/CreateNewJob/Product/DEEC/DEECSlice.js";
import { useCreateProductEPCGTableOneMutation, useCreateProductEPCGTableTwoMutation, useDeleteProductEPCGTableOneMutation, useDeleteProductEPCGTableTwoMutation, useLazyGetProductEPCGTableOneQuery, useLazyGetProductEPCGTableTwoQuery, useUpdateProductEPCGTableOneMutation, useUpdateProductEPCGTableTwoMutation } from "./ExportPage/CreateNewJob/Product/EPCG/EPCGSlice.js";
import { useCreateProductDFIATableOneMutation, useCreateProductDFIATableTwoMutation, useDeleteProductDFIATableOneMutation, useDeleteProductDFIATableTwoMutation, useLazyGetProductDFIATableOneQuery, useLazyGetProductDFIATableTwoQuery, useUpdateProductDFIATableOneMutation, useUpdateProductDFIATableTwoMutation } from "./ExportPage/CreateNewJob/Product/DFIA/DFIASlice.js";

//"@/redux/ExportPage/Masters/Masters";



export const hookMap = {
  // Queries
  exporter: (id) => {
    const [create, createState] = useCreateExporterMutation();
    const [update, updateState] = useUpdateExporterMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetExportGeneralByIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };

    return { create, update, createState, updateState, data, isLoading, fetch };
  },
  // Queries
  entity: (id) => {
    const [create, createState] = useCreateEntityMutation();
    const [update, updateState] = useUpdateEntityMutation();
    const [deleteFn, deleteState] = useDeleteEntityMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetEntityByMasterIdQuery();

    // Helper function to fetch by ID
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };

    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

  jobwork: (id) => {
    const [create, createState] = useCreateJobworkMutation();
    const [update, updateState] = useUpdateJobworkMutation();
    const [deleteFn, deleteState] = useDeleteJobworkMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetJobworkByMasterIdQuery(id);

    // Helper function to fetch by ID
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };

    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

  requirement: (id) => {
    const [create, createState] = useCreateRequirementMutation();
    const [update, updateState] = useUpdateRequirementMutation();
    const [deleteFn, deleteState] = useDeleteRequirementMutation();
    const [fetchRequirement, { data, isLoading }] =
      useLazyGetRequirementByMasterIdQuery(id);
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchRequirement({ id }).unwrap();
      return response;
    };

    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

  sez: (id) => {
    const [update, updateState] = useUpdateSezInfoMutation();
    const [create, createState] = useUpdateSezInfoMutation();

    const [fetchSezById, { data, isLoading }] = useLazyGetSezInfoByIdQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchSezById({ id }).unwrap();
      return response;
    };

    return { create, createState, update, updateState, fetch, data, isLoading };
  },
  container: () => {
    const [create, createState] = useCreateContainerMutation();
    const [update, updateState] = useUpdateContainerMutation();
    const [deleteFn, deleteState] = useDeleteContainerMutation();
    const [fetchContainerById, { data, isLoading }] =
      useLazyGetContainerByMasterIdQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchContainerById({ id }).unwrap();
      return response;
    };
    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },
  

  mainShipment : (id) => {
    const [create, createState] = useCreateMainShipmentMutation(); 
    const [ fetchMainShipmentById , { data, isLoading }] = useLazyGetMainShipmentByIdQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchMainShipmentById({ id }).unwrap();
      return response;
    }

    return { create, createState , fetch, data, isLoading };
  },

  shipmentStuffing: (id) => {
    const [create, createState] = useUpdateShipmentStuffingMutation();
    const [fetchShipmentById, { data, isLoading }] =
      useLazyGetShipmentStuffingByIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchShipmentById({ id }).unwrap();
      return response;
    };

    return { create, createState, fetch, data, isLoading };
  },

  shipmentExBondDetails: (id) => {
    const [create, createState] = useCreateExbondMutation();
    const [update, updateState] = useUpdateExbondMutation();
    const [deleteFn, deleteState] = useDeleteExbondMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetShipmentExbondByIdQuery(id);

    // Helper function to fetch by ID
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };
    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

  exchangeRate: (id) => {
    const [create, cretaeState] = useUpdateExchangeRateMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetExchangeRateByIdQuery();

    // Helper function to fetch by ID
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };
    return { data, isLoading, fetch, create, cretaeState };
  },

  invoiceMain: (id) => {
    const [create, createState] = useCreateInvoiceMutation();
    const [update, updateState] = useUpdateInvoiceMutation();
    const [deleteFn, deleteState] = useDeleteInvoiceMutation();
    const [fetchInvoiceById, { data, isLoading }] =
      useLazyGetInvoiceByMasterIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchInvoiceById({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
      update,
      updateState,
      deleteFn,
      deleteState,
    };
  },
  invoiceBuyer: (id, subId) => {
    const [update, updateState] = useUpdateInvoiceBuyerMutation();
    const [create, createState] = useUpdateInvoiceBuyerMutation();
    const [fetchInvoiceById, { data, isLoading }] =
      useLazyGetInvoiceBuyerByIdQuery();
    const fetch = async ({ id, subId }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = subId
        ? await fetchInvoiceById({ id, subId }).unwrap()
        : await fetchInvoiceById({ id }).unwrap();

      return response;
    };

    return { update, updateState, fetch, data, isLoading, create, createState };
  },

  invoiceOtherinfo: (id, subId) => {
    const [create, createState] = useCreateInvoiceOtherinfoMutation();
    const [update, updateState] = useUpdateInvoiceOtherinfoMutation();
    const [fetchInvoiceById, { data, isLoading }] =
      useLazyGetInvoiceOtherinfoByIdQuery();

    const fetch = async ({ id, subId }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = subId
        ? await fetchInvoiceById({ id, subId }).unwrap()
        : await fetchInvoiceById({ id }).unwrap();
      return response;
    };
    return { create, createState, update, updateState, fetch, data, isLoading };
  },

  invoiceFreight: () => {
    const [create, createState] = useUpdateInvoiceFreightMutation();
    const [fetchExportById, { data, isLoading }] = useLazyGetInvoiceByIdQuery();
    const fetch = async ({ id, subId }) => {
      if (!id)
        throw new Error("❌ ID is required to fetch freight insurance data");

      // Only send id + subId (no rows here, that's for PUT)
      const response = subId
        ? await fetchExportById({ id, subId }).unwrap()
        : await fetchExportById({ id }).unwrap();
      return response;
    };

    return {
      create,
      createState,
      fetch,
      data,
      isLoading,
    };
  },

  productMain: (id) => {
    const [create, createState] = useCreateProductMainMutation();
    const [update, updateState] = useUpdateProductMainMutation();
    const [deleteFn, deleteState] = useDeleteProductMainMutation();

    const [fetchProductMain, { data, isLoading }] =
      useLazyGetProductInvoiceMainIdQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchProductMain({ id }).unwrap();
      return response;
    };

    return {
      create,
      createState,
      update,
      updateState,
      data,
      isLoading,
      fetch,
      deleteFn,
      deleteState,
    };
  },

  productGeneral: (id) => {
    const [create, createState] = useCreateProductGeneralMutation();
    const [fetchProductGeneral, { data, isLoading }] =
      useLazyGetAllGeneralQuery(id);
    const [update, updateState] = useUpdateProductGeneralMutation();
    // Optional helper function if you want to refetch or manipulate data
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchProductGeneral({ id }).unwrap();
      return response;
    };
    // const [deleteFn, deleteState] = useDeleteProductGeneralMutation();
    return { create, createState, update, updateState, data, isLoading, fetch };
  },
  //AreDetails
  productAreDetails: (id) => {
    const [create, createState] = useCreateProductAreDetailsMutation();
    const [update, updateState] = useUpdateProductAreDetailsMutation();
    const [fecthAreDetails, { data, isLoading }] =
      useLazyGetAreDetailsByIdQuery(id); //useLazyGetAreDetailsQuery
    const fetch = async ({ id, subId }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");

      const response = subId
        ? await fecthAreDetails({ id, subId }).unwrap()
        : await fecthAreDetails({ id }).unwrap();
      return response;
    };

    const [deleteFn, deleteState] = useDeleteProductAreDetailsMutation();
    return {
      create,
      createState,
      data,
      isLoading,
      fetch,
      update,
      updateState,
      deleteFn,
      deleteState,
    };
  },
  //DUC Info
  productDucInfo: (id) => {
    const [create, createState] = useCreateProductDucInfoMutation();

    const [update, updateState] = useUpdateProductDucInfoMutation();
    const [fecthDucDetails, { data, isLoading }] =
      useLazyGetDucInfoDetailsByIdQuery(id);
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");

      const response = await fecthDucDetails({ id }).unwrap();
      return response;
    };
    const [deleteFn, deleteState] = useDeleteProductDucInfoMutation();
    return {
      create,
      createState,
      data,
      isLoading,
      fetch,
      update,
      updateState,
      deleteFn,
      deleteState,
    };
  },

  productdrawback: (id) => {
    const [create, createState] = useCreateDrawBackMutation();
    const [fetchdrawback, { data, isLoading }] =
      useLazyGetDrawBackByMasterIdQuery(id);
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchdrawback({ id }).unwrap();
      return response;
    };
    return { create, createState, data, isLoading, fetch };
  },

  shipmentbillprint: (id) => {
    const [create, createState] = useCreateShipmentBillMutation();
    const [fetchShipmentBill, { data, isLoading }] =
      useLazyGetShipmentBillByIdQuery(id);
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchShipmentBill({ id }).unwrap();
      return response;
    };
    return { create, createState, data, isLoading, fetch };
  },

  shipmentinvoiceprint: (id) => {
    const [create, createState] = useCreateShipmentInvoiceMutation();
    const [fetchShipmentinvoice, { data, isLoading }] =
      useLazyGetShipmentInvoiceByIdQuery({ id });
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchShipmentinvoice({ id }).unwrap();
      return response;
    };
    return { create, createState, data, isLoading, fetch };
  },

  productDFRCForm: (id) => {
    const [create, createState] = useCreateProductDFRCMutation();
    const [fetchDFRCFormById, { data, isLoading }] =
      useLazyGetProductDFRCQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchDFRCFormById({ id }).unwrap();
      return response;
    };
    return { create, createState, data, isLoading, fetch };
  },

  udf: (id) => {
    const [create, createState] = useCreateUdfMutation();
    const [fetchudf, { data, isLoading }] = useLazyGetUdfByMasterIdQuery(id);
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchudf({ id }).unwrap();
      return response;
    };
    return { create, createState, data, isLoading, fetch };
  },

  //DoC Info

  productDocInfo: (id) => {
    const [create, createState] = useCreateProductDocInfoMutation();
    const [update, updateState] = useUpdateProductDocInfoMutation();
    const [fetchDocdDetails, { data, isLoading }] =
      useLazyGetDocInfoDetailsByIdQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");

      const response = await fetchDocdDetails({ id }).unwrap();
      return response;
    };
    const [deleteFn, deleteState] = useDeleteProductDocInfoMutation();
    return {
      create,
      createState,
      data,
      isLoading,
      fetch,
      update,
      updateState,
      deleteFn,
      deleteState,
    };
  },

  productReExport: (id) => {
    const [create, createState] = useCreateReExportMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetProductReExportByIdQuery(id);
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };

    return { create, createState, data, isLoading, fetch };
  },
  //useCreateExportNotesMutation

  productDEPBForm: (id) => {
    const [create, createState] = useCreateProductDEPBMutation();
    const [fetchDEPBFormById, { data, isLoading }] =
      useLazyGetProductDEPBQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchDEPBFormById({ id }).unwrap();
      return response;
    };

    return { create, createState, data, isLoading, fetch };
  },

  productDEPBTable: (id) => {
    const [create, createState] = useCreateProductDEPBTableMutation();
    const [update, updateState] = useUpdateProductDEPBTableMutation();
    const [deleteTableFn, deleteState] = useDeleteProductDEPBTableMutation();
    const [fetchDEPBTableById, { data, isLoading }] =
      useLazyGetProductDEPBTableQuery();
    const fetchTable = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchDEPBTableById({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      data,
      isLoading,
      fetchTable,
      update,
      updateState,
      deleteTableFn,
      deleteState,
    };
  },
   productDEECTableOne: (id) => {
    const [create, createState] = useCreateProductDEECTableOneMutation();
    const [update, updateState] = useUpdateProductDEECTableOneMutation();
    const [deleteFn, deleteFnState] = useDeleteProductDEECTableOneMutation();
    const [fetchDEECTableOneById, { data, isLoading }] =
      useLazyGetProductDEECTableOneQuery();
    const fetchMultiTable = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchDEECTableOneById({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      data,
      isLoading,
      fetchMultiTable,
      update,
      updateState,
      deleteFn,
      deleteFnState,
    };
  },
    productDEECTableTwo: (id) => {
    const [create, createState] = useCreateProductDEECTableTwoMutation();
    const [update, updateState] = useUpdateProductDEECTableTwoMutation();
    const [deleteFn, deleteFnState] = useDeleteProductDEECTableTwoMutation();
    const [fetchDEECTableTwoById, { data, isLoading }] =
      useLazyGetProductDEECTableTwoQuery();
    const fetchMultiTable = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchDEECTableTwoById({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      data,
      isLoading,
      fetchMultiTable,
      update,
      updateState,
      deleteFn,
      deleteFnState,
    };
  },
   productEPCGTableOne: (id) => {
    const [create, createState] = useCreateProductEPCGTableOneMutation();
    const [update, updateState] = useUpdateProductEPCGTableOneMutation();
    const [deleteFn, deleteFnState] = useDeleteProductEPCGTableOneMutation();
    const [fetchEPCGTableOneById, { data, isLoading }] =
      useLazyGetProductEPCGTableOneQuery();
    const fetchMultiTable = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchEPCGTableOneById({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      data,
      isLoading,
      fetchMultiTable,
      update,
      updateState,
      deleteFn,
      deleteFnState,
    };
  },
    productEPCGTableTwo: (id) => {
    const [create, createState] = useCreateProductEPCGTableTwoMutation();
    const [update, updateState] = useUpdateProductEPCGTableTwoMutation();
    const [deleteFn, deleteFnState] = useDeleteProductEPCGTableTwoMutation();
    const [fetchEPCGTableTwoById, { data, isLoading }] =
      useLazyGetProductEPCGTableTwoQuery();
    const fetchMultiTable = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchEPCGTableTwoById({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      data,
      isLoading,
      fetchMultiTable,
      update,
      updateState,
      deleteFn,
      deleteFnState,
    };
  },
  productDFIATableOne: (id) => {
    const [create, createState] = useCreateProductDFIATableOneMutation();
    const [update, updateState] = useUpdateProductDFIATableOneMutation();
    const [deleteFn, deleteFnState] = useDeleteProductDFIATableOneMutation();
    const [fetchDFIATableOneById, { data, isLoading }] =
      useLazyGetProductDFIATableOneQuery();
    const fetchMultiTable = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchDFIATableOneById({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      data,
      isLoading,
      fetchMultiTable,
      update,
      updateState,
      deleteFn,
      deleteFnState,
    };
  },
    productDFIATableTwo: (id) => {
    const [create, createState] = useCreateProductDFIATableTwoMutation();
    const [update, updateState] = useUpdateProductDFIATableTwoMutation();
    const [deleteFn, deleteFnState] = useDeleteProductDFIATableTwoMutation();
    const [fetchDFIATableTwoById, { data, isLoading }] =
      useLazyGetProductDFIATableTwoQuery();
    const fetchMultiTable = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchDFIATableTwoById({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      data,
      isLoading,
      fetchMultiTable,
      update,
      updateState,
      deleteFn,
      deleteFnState,
    };
  },

  productDFRCForm: (id) => {
    const [create, createState] = useCreateProductDFRCMutation();
    const [fetchDFRCFormById, { data, isLoading }] =
      useLazyGetProductDFRCQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchDFRCFormById({ id }).unwrap();
      return response;
    };
    return { create, createState, data, isLoading, fetch };
  },

  productDFRCTable: (id) => {
    const [create, createState] = useCreateProductDFRCTableMutation();
    const [update, updateState] = useUpdateProductDFRCTableMutation();
    const [deleteTableFn, deleteState] = useDeleteProductDFRCTableMutation();
    const [fetchDFRCTableById, { data, isLoading }] =
      useLazyGetProductDFRCTableQuery();
    const fetchTable = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchDFRCTableById({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      data,
      isLoading,
      fetchTable,
      update,
      updateState,
      deleteTableFn,
      deleteState,
    };
  },

  shipmentAnnuxForm: (id) => {
    const [create, createState] = useCreateAnnexMutation();
    const [fetchAnnuxFormById, { data, isLoading }] =
      useLazyGetShipmentAnnexByIdQuery();
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchAnnuxFormById({ id }).unwrap();
      return response;
    };
    return { create, createState, data, isLoading, fetch };
  },

  shipmentAnnuxTable: (id) => {
    const [create, createState] = useCreateDocumentMutation();
    const [update, updateState] = useUpdateDocumentMutation();
    const [deleteTableFn, deleteState] = useDeleteDocumentMutation();
    const [fetchshipmentTableById, { data, isLoading }] =
      useLazyGetShipmentDocumentByIdQuery();
    const fetchTable = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchshipmentTableById({ id }).unwrap();
      return response;
    };
    return {
      create,
      createState,
      data,
      isLoading,
      fetchTable,
      update,
      updateState,
      deleteTableFn,
      deleteState,
    };
  },

  ProductQuota: (id) => {
    const [create, createState] = useCreateQuotaMutation();
    const [update, updateState] = useUpdateQuotaMutation();
    const [deleteFn, deleteState] = useDeleteQuotaMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetProductQuotaByIdQuery(id);

    // Helper function to fetch by ID
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };
    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

  ProductAdditionalinfo: (id) => {
    const [create, createState] = useCreateAdditionalInfoMutation();
    const [update, updateState] = useUpdateAdditionalInfoMutation();
    const [deleteFn, deleteState] = useDeleteAdditionalInfoMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetAdditionalInfoByIdQuery(id);
    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

  ProductAdditionalinfo: (id) => {
    const [create, createState] = useCreateAdditionalInfoMutation();
    const [update, updateState] = useUpdateAdditionalInfoMutation();
    const [deleteFn, deleteState] = useDeleteAdditionalInfoMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetAdditionalInfoByIdQuery(id);

    // Helper function to fetch by ID
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };
    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },
  //notes

  exportNotes: (id) => {
    const [create, createState] = useCreateExportNotesMutation();
    const [update, updateState] = useUpdateExportNotesMutation();
    const [fecthNotesDetails, { data, isLoading }] =
      useLazyGetNotesByExporterIdQuery(id);
    const [fileUpload, fileUploadState] = useFileUploadMutation();
    const fetch = async ({ id, subId }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");

      const response = subId
        ? await fecthNotesDetails({ id, subId }).unwrap()
        : await fecthNotesDetails({ id }).unwrap();
      return response;
    };
    const [deleteFn, deleteState] = useDeleteExportNoteMutation();
    return {
      create,
      createState,
      update,
      updateState,
      data,
      isLoading,
      fetch,
      deleteFn,
      deleteState,
      fileUpload,
      fileUploadState,
    };
  },

  exporthistory: (id) => {
    const [fetchHistoryDetails, { data, isLoading }] = useLazyGetHistoryQuery();

    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");

      const response = await fetchHistoryDetails({ id }).unwrap();
      return response;
    };

    return { data, isLoading, fetch };
  },

  ProductConstituent: (id) => {
    const [create, createState] = useCreateConstituentMutation();
    const [update, updateState] = useUpdateConstituentMutation();
    const [deleteFn, deleteState] = useDeleteConstituentMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetConstituentsByIdQuery(id);
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };

    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

  ProductControl: (id) => {
    const [create, createState] = useCreateControlDetailMutation();
    const [update, updateState] = useUpdateControlDetailMutation();
    const [deleteFn, deleteState] = useDeleteControlDetailMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetControlDetailsByIdQuery(id);

    // Helper function to fetch by ID
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };

    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

  TrackingDetails: (id) => {
    const [create, createState] = useCreateExportTrackingMutation();
    const [update, updateState] = useUpdateExportTrackingMutation();
    const [fetchExportById, { data, isLoading }] =
    useLazyGetTrackingByExportMasterIdQuery();
  
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required");
      return await fetchExportById({ id }).unwrap();
    };
  
    return { create, update, createState, updateState, data, isLoading, fetch };
  },
  

  ProductDetails: (id) => {
    const [create, createState] = useCreateProductionDetailMutation();
    const [update, updateState] = useUpdateProductionDetailMutation();
    const [deleteFn, deleteState] = useDeleteProductionDetailMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetProductionDetailsByIdQuery(id);

    // Helper function to fetch by ID
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };

    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

  productOtherInfo: (id) => {
    const [create, createState] = useCreateOtherDetailMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetOtherDetailsByIdQuery(id);
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };

    return { create, createState, data, isLoading, fetch };
  },

  productCess: (id) => {
    const [create, createState] = useUpdateCessMutation();
    const [fetchExportById, { data, isLoading }] =
      useLazyGetProductCessByIdQuery(id);
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchExportById({ id }).unwrap();
      return response;
    };
    return { data, isLoading, fetch, create, createState };
  },

  esanchit: (id) => {
    const [create, createState] = useCreateESanchitMutation();
    const [update, updateState] = useUpdateESanchitMutation();
    const [deleteFn, deleteState] = useDeleteESanchitMutation();
    const [fetchesanchit, { data, isLoading }] =
      useLazyGetESanchitByMasterIdQuery(id);

    // Helper function to fetch by ID
    const fetch = async ({ id }) => {
      if (!id) throw new Error("ID is required to fetch exporter data");
      const response = await fetchesanchit({ id }).unwrap();
      return response;
    };

    return {
      create,
      update,
      createState,
      updateState,
      deleteFn,
      deleteState,
      data,
      isLoading,
      fetch,
    };
  },

    eSanchitFilter : () =>{
    const [fetchEsanchitFilter , {data,isLoading , error}]  = useLazyGetFilterESanchitQuery()

    const fetch = async ({id,data}) =>{
      if(!id) throw new Error("ID is required to fetch exporter data")
      const response = await fetchEsanchitFilter({id,data}).unwrap()
      return response
    }
    return {fetch,data,isLoading,error}
  },
  getOrganization: useGetOrganizationQuery,
  getDashboard: useGetDashboardQuery,
  getExportId: useGetExportIdQuery,
  getExporters: useGetExportersQuery,
  getCustomers : useGetCustomersQuery,
  getQualifierCode : useGetQualifierCodeQuery,
  getESanchitDocument : useGetESanchitDocumentQuery,
  getCustomersAddress : () => {
    const [fetchCustomerAddress,{data,isLoading,error}] = useLazyGetCustomersAddressQuery()

    const fetch = async ({id}) =>{
      if(!id) throw new Error("ID is required to fetch cusotmer address")
        const response = await fetchCustomerAddress({id}).unwrap()
      return response;
    }
    return {fetch , data, isLoading,error}
  },
  
 // getInvoice: useGetInvoiceQuery,
  getInvoiceMaster:useLazyGetInvoiceByMasterIdQuery,
  getOtherdetails: useLazyGetOtherDetailsByIdQuery,
  getRequirement: useLazyGetRequirementByMasterIdQuery, //Ni
  getUdf: useLazyGetUdfByMasterIdQuery,
  getAdditionalInfo: useLazyGetAdditionalInfoByIdQuery,
  getExbond: useLazyGetShipmentExbondByIdQuery,
  getJobWork: useLazyGetJobworkByMasterIdQuery,
  getProduction: useLazyGetProductionDetailsByIdQuery,
  getControl: useLazyGetControlDetailsByIdQuery,
  getPorts: useGetPortsQuery,
  getQuantity: useGetQuantityQuery,
  getCFS: useGetCFSQuery,
  getVolume: useGetVolumeQuery,
  getExchange: useGetExchangeQuery,
  getIECode: useGetIECodeQuery,
  getCustomer:useGetCustomerQuery,
  getGateway: useGetGatewayQuery,
  getCountry: useGetCountryQuery,
  getInvoiceMaster:useGetInvoiceMasterQuery,
  getAirline: useGetAirlineQuery,
  getDrawer: useGetDrawerQuery,
  getCity: useGetCityQuery,
  getGateWayPort: ()=>{
     const { data, isLoading, refetch } = useGetGatewayQuery();

  const fetch = async () => {
    const response = await refetch();
    return response?.data;
  };

  return { data, isLoading, fetch };
  },

  getState: useGetStateQuery,
  getFilterHsnCode :useGetFilterHsnCodeQuery,
 // getCustomehouse: useGetCustomehouseQuery,
  getStateMaster: useGetStateMasterQuery,
  getPackageDetails: useGetPackageDetailsByMasterIdQuery,
  getPackageDetailsById: useyGetPackageDetailsByIdQuery,
  getShipLineMaster : useGetShiplineMasterQuery,
  getCustomerType : useGetCustomertypeMasterQuery,
  //filemutaton
  getNotation:useGetNotationQuery,
  fileUpload: useFileUploadMutation,
  getCurrencies: useGetCurrenciesQuery,
  getInvoiceById: useLazyGetInvoiceByIdQuery,
  getInvoiceBuyerByMasterId: useGetInvoiceBuyerByMasterIdQuery,
  getInvoiceBuyerById: useLazyGetInvoiceBuyerByIdQuery,
  getInvoiceOtherinfoByMasterId: useGetInvoiceOtherinfoByMasterIdQuery,
  getInvoiceOtherinfoById: useLazyGetInvoiceOtherinfoByIdQuery,
  geteSanchitManiById: useLazyGetESanchitByMasterIdQuery,
  getShipmentInvoiceById: useLazyGetShipmentInvoiceByIdQuery,
  getAreDetailsById: useLazyGetAreDetailsByIdQuery,
  getAreDetails: useLazyGetAreDetailsQuery,
  getHistory: useLazyGetHistoryQuery,
  // getExporters: useGetExportersQuery,
  getDescription: useGetDescriptionQuery,
  getHsnCodeMaster: useGetHsnCodeMasterQuery,
  getFTAMaster: useGetFTAMasterQuery,
  // //Product General
  getAllGeneral: useLazyGetAllGeneralQuery,
  getShipmentAnnexById: useLazyGetShipmentAnnexByIdQuery,
  getShipmentDocumentById: useLazyGetShipmentDocumentByIdQuery,
  getProductById: useLazyGetDrawBackByMasterIdQuery,
  // getShipmentBill:useGetShipmentBillByIdQuery,
  getProductQuotaById: useLazyGetProductQuotaByIdQuery,
  getProductAREById: useGetProductAREByIdQuery,
  // getDrawback:useCreateDrawBackMutation,
  getProductReExport: useLazyGetProductReExportByIdQuery,
  getProductById: useLazyGetConstituentsByIdQuery,
  updateProductAreDetails: useUpdateProductAreDetailsMutation,
  getRateListMaster: useGetRateListMasterQuery,
  // getProductReExport: useGetProductReExportByIdQuery,
  updateProductAreDetails: useUpdateProductAreDetailsMutation,
  getEximCodeData : useLazyGetEximCodeQuery,
  //ProductDucInfo
  getDucInfoDetailsById: useLazyGetDucInfoDetailsByIdQuery,
  getExchangeMasterId: () => {
    const { formData } = useUser();

    // Try getting productId from context
    const productMain = formData?.productMain ?? [];
    const selectedProduct = productMain.find((item) => item.selected === true);
    const productId = selectedProduct?.id;

    // Skip calling the query if no ID yet
    const { data, isLoading } = useGetExchangeMasterIdQuery(
      { id: productId },
      {
        skip: !productId,
      }
    );

    return { data, isLoading, productId };
  },
  getEndUseCode: useGetEndUseCodeMasterQuery,
  getDistrictMaster: useGetDistrictMasterQuery,
  //productDocinfo
  getDocInfoDetailsById: useLazyGetDocInfoDetailsByIdQuery,
  getNotesByExporterId: useLazyGetNotesByExporterIdQuery,
  getESanchitInvoiceQuery: () =>{
      const {exporterId} = useParams()
  const {exporterMasterId} = useUser()
  const {data,isLoading} = useGetExportInvoiceQuery({id :exporterMasterId || exporterId})
  return {data,isLoading}
  },
  
  // getDrawBackByCustomHouseIdQuery: () => {
  //   const { customerId } = useParams();
  //   // const { customHouseId } = useUser();
  
  //   const { data, isLoading } = useLazyGetDrawBackByCustomHouseIdQuery({
  //     customerId: customerId,
  //     id: id
  //   });
  
  //   return { data, isLoading };
  // },

  getDrawBackByCustomHouseIdQuery:() =>
    {
    const {customerId } = useParams();
    
  
      const[fetchcustomHouse,{data,isLoading,error}] = useLazyGetDrawBackByCustomHouseIdQuery()
      const fetch = async ({id}) =>{
        if(!id) throw new Error("ID is required to fetch cusotmer address")
          const response = await fetchcustomHouse({customerId,id}).unwrap()
        console.log(response,"customeHouseId drawbackdetails")
        return response;
      }
      return {fetch , data, isLoading,error}
    },
  
  // Mutations  
  login: useLoginMutation,
  forgotPassword: useForgotPasswordMutation,
  emailOtp: useEmailOtpMutation,
  resendOtp: useResendOtpMutation,
  resetPassword: useResetPasswordMutation,
  toggleLock: useToggleLockMutation,
  deleteJob: useDeleteJobMutation,
  // updateEntity: useUpdateEntityMutation,
  updateContainer: useUpdateContainerMutation,
  deleteContainer: useDeleteContainerMutation,
  createContainer: useCreateContainerMutation,
  createRequirement: useCreateRequirementMutation,
  updateRequirement: useUpdateRequirementMutation,
  deleteRequirement: useDeleteRequirementMutation,
  updateJobwork: useUpdateJobworkMutation,
  deleteJobwork: useDeleteJobworkMutation,
  createJobwork: useCreateJobworkMutation,
  getLic : useGetLicQuery,
 getCityMaster :useGetCityMasterQuery,
 getShipingLine:useGetShipingLineQuery,
 getEximCode:useGetEximCodeQuery,
 getAdCodeMaster :useGetAdCodeMasterQuery,
 getCustomeHouse:useGetCustomeHouseQuery,
};


